import { render, staticRenderFns } from "./dashboard-account-select.component.vue?vue&type=template&id=2222987f"
import script from "./dashboard-account-select.component.vue?vue&type=script&lang=js"
export * from "./dashboard-account-select.component.vue?vue&type=script&lang=js"
import style0 from "./dashboard-account-select.component.vue?vue&type=style&index=0&id=2222987f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports